import React from 'react'
import { Box } from '@mui/material'
import TopNavigation from '@/design-system/organisms/TopNavigation'
import { SkipToMainContent } from '@/design-system/atoms/SkipToMainContent'
import { Footer } from '@/design-system/organisms/Footer'

interface LayoutProps {
    children: React.ReactNode
    variant?: 'full' | 'simplified'
    showAuthLinks?: boolean
    mainContentId?: string
    hideFooter?: boolean
}

const Layout: React.FC<LayoutProps> = ({
    children,
    variant = 'full',
    showAuthLinks = false,
    mainContentId = 'main-content',
    hideFooter = false,
}) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <SkipToMainContent targetId={mainContentId} />
            <TopNavigation variant={variant} showAuthLinks={showAuthLinks} />
            <Box
                id={mainContentId}
                component="main"
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0, // Allow flex children to shrink below content size
                }}
                tabIndex={-1}
            >
                {children}
            </Box>
            {!hideFooter && <Footer />}
        </Box>
    )
}

export default Layout
